export const DEFAULT_CONTENT = [
  {
    title: 'Fewer than 1 pregnancy',
    list: [
      [
        {
          items: [
            [
              'Implants (NEXPLANON)',
              'Injections',
              'Intrauterine devices',
              'Sterilization',
            ],
          ],
        },
      ],
      [
        {
          items: [
            ['Birth control pills', 'Skin patch', 'Vaginal ring with hormones'],
          ],
        },
      ],
      [
        {
          items: [['Condoms', 'Diaphragm']],
        },
      ],
    ],
  },
  {
    title: '10-20 pregnancies',
    list: [
      [
        {
          items: [
            [
              'No sex during the most fertile days of the monthly cycle',
              'Spermicide',
              'Withdrawal',
            ],
          ],
        },
      ],
    ],
  },
  {
    title: '85 or more pregnancies',
    list: [
      [
        {
          items: [['No birth control']],
        },
      ],
    ],
  },
];

export const DEFAULT_HEADLINE = {
  title: 'Fewer pregnancies',
  subtitle: '(Per 100 women in 1 year)',
};

export const DEFAULT_FOOTER_TEXT = 'More pregnancies';

export const BLOCK_DESCRIPTION = {
  title: 'What are some birth control options?',
  content:
    'This chart shows the chance of getting pregnant for women who use different methods of birth control. Each box in the chart contains a list of birth control methods that are similar in effectiveness. The most effective methods are at the top of the chart.',
};

export const BLOCK_DESCRIPTION_BIRTH_CONTROL = {
  title: 'what are some birth control options?',
  content:
    'This chart shows the chances of getting pregnant for women who use different methods of birth control. Each colored area of the chart contains a list of birth control methods that are similar in effectiveness. The most effective methods are at the top, the least at the bottom. (Pregnancies per 100 women in 1 year.)',
};
